import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19273 19273"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:279.319;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528240205616">
        <path
          d="M140 140h18994v1524H140zM7899 1913s-874 6116-4966 8405l5 633c1856 2995 1856 8182 1856 8182H154V1664M154 10398h2779M154 11004h2691M2134 11184v1636"
          className="fill-none stroke1"
          style={{
            strokeWidth: 279.319,
            strokeLinecap: "round",
          }}
        />
        />
        <path
          d="M2845 8381s2329-2613 2922-5289M11389 1913s874 6116 4965 8405l-5 633c-1855 2995-1855 8182-1855 8182h4639V1664M19034 10398h-2778M19034 11004h-2689M17055 11184v1636"
          className="fill-none stroke1"
          style={{
            strokeWidth: 279.319,
            strokeLinecap: "round",
          }}
        />
        <path
          d="M16345 8381s-2330-2613-2923-5289"
          className="fill-none stroke1"
          style={{
            strokeWidth: 279.319,
            strokeLinecap: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
